import { getItemFromCollection } from "directus/src/operations";

export async function fetchFunctionData({ functionId }) {
  try {
    const response = await getItemFromCollection("functions", functionId);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
